import { cloneDeep } from 'lodash-es';

// export const DefaultVideoConfig = {
//   audio: false,
//   video: {
//     width: {
//       ideal: 640,
//       max: 640,
//     },
//     height: {
//       ideal: 480,
//       max: 480,
//     },
//     frameRate: 15,
//   },
// };

// export const DefaultAudioConfig = {
//   audio: {
//     echoCancellation: true,
//     noiseSuppression: true,
//     autoGainControl: true,
//     sampleRate: 48000,
//   },
//   video: false,
// };

export const DefaultMediaConfig = {
  audio: true,
  video: {
    width: {
      ideal: 640,
      max: 640,
    },
    height: {
      ideal: 480,
      max: 480,
    },
    frameRate: 15,
  },
};

const LocalStoreName = 'PC_MEDIA_CONFIG_ABOUT_CURRENT';

export function getMediaConfig() {
  const LocalStoreData = window.localStorage.getItem(LocalStoreName);
  let localStoreConfig = DefaultMediaConfig;
  if (LocalStoreData) {
    try {
      const data = JSON.parse(LocalStoreData) || {};
      localStoreConfig = Object.assign(cloneDeep(DefaultMediaConfig), data);
    } catch (e) {
      localStoreConfig = DefaultMediaConfig;
    }
  }
  return localStoreConfig;
}

export function setMediaConfig(config: any) {
  window.localStorage.setItem(LocalStoreName, JSON.stringify(config));
}

export function clearLocalMediaConfig() {
  window.localStorage.removeItem(LocalStoreName);
}
